export default __webpack_public_path__ + "static/media/person.ad125908.svg";